<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="grup && grup.group_id ? 'Ubah Grup Jadwal Kerja' : 'Tambah Grup Jadwal Kerja'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="8" lg="8" xl="8">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row wrap justify-center>
              <v-col cols="12" class="py-0">
                <label class="caption mb-2 grey--text">Label Grup</label>
                <v-text-field
                  autofocus
                  dense
                  single-line
                  outlined
                  label="Label Grup"
                  v-model="grup.nama"
                  hint="Masukkan Label Grup"
                  data-vv-name="nama"
                  data-vv-as="Label Grup"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" class="py-0">
                <label class="caption mb-2 grey--text">Keterangan</label>
                <v-textarea
                  dense
                  single-line
                  outlined
                  label="Deskripsi"
                  v-model="grup.keterangan"
                  hint="Informasi yang Mendeskripsikan tentang Grup yang Dibuat"
                  data-vv-name="keterangan"
                  data-vv-as="Keterangan"
                  v-validate
                  rows="2"
                  :error-messages="errors.collect('form.keterangan')"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12">
                <div class="title primary--text mb-3"> Pilih Anggota Dalam Grup </div>
                <v-text-field
                  label="Masukan Nama"
                  append-icon="mdi-magnify"
                  outlined
                  dense
                  v-model="textSearch"
                  @input="searchInput"
                />

                <div class="d-flex justify-space-between my-3 mx-3">
                  <div>
                    <span class="primary--text">{{ selectedItems.length }}</span> Anggota Terpilih
                  </div>
                  <div class="primary--text" style="cursor: pointer" @click="onShowSelected"> Lihat Anggota Grup </div>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :items-per-page="15"
                  item-key="user_id"
                  show-select
                  hide-default-footer
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.user_id">
                        <td>
                          <v-checkbox
                            v-model="selectedItems"
                            :value="item.user_id"
                            style="margin: 0px; padding: 0px"
                            hide-details
                          />
                        </td>
                        <td>{{ item.nama }}</td>
                        <td>
                          {{ (item && item.no_pegawai) || '-' }}
                        </td>
                        <td>
                          <v-chip text small class="white--text" :color="item.is_face_verified ? 'green' : 'red'">
                            {{ item.is_face_verified ? 'Terverifikasi' : 'Belum Verifikasi' }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:footer>
                    <v-row wrap class="pb-3" v-if="page">
                      <v-col cols="9" v-if="page && $vuetify.breakpoint.smAndUp" class="text-center">
                        <v-pagination
                          v-if="page.total"
                          :key="page_key"
                          v-model="current_page"
                          :length="page.last_page"
                          :total-visible="7"
                          @input="change"
                        ></v-pagination>
                      </v-col>
                      <v-col :cols="$vuetify.breakpoint.smAndUp ? 3 : 9" v-if="page.from" class="text-right">
                        <p class="caption font-weight-bold">
                          {{ page.from }} - {{ page.to }} dari
                          {{ page.total }}
                        </p>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="700" close>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text">Lihat Anggota Grup</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-5">
        <v-card-text>
          <div class="d-flex justify-space-between my-3 mx-3">
            <div>
              <span class="primary--text">{{ selectedItems.length }}</span> Daftar Anggota Grup
            </div>
          </div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <td></td>
                  <td class="text-left">Nama Anggota</td>
                  <td class="text-left">NIP</td>
                  <td>Verifikasi Wajah</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in selectedItems" :key="i">
                  <td>
                    <v-checkbox
                      v-model="selectedItems"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td class="text-left">
                    {{ getDeepObj(members.find((data) => Number(data.user_id) === Number(item)) || {}, 'nama') }}
                  </td>
                  <td class="text-left">
                    {{ getDeepObj(members.find((data) => Number(data.user_id) === Number(item)) || {}, 'no_pegawai') || '' }}
                  </td>
                  <td class="text-left">
                    <v-chip
                      small
                      outlined
                      :color="
                        Number(
                          getDeepObj(
                            members.find((data) => Number(data.user_id) === Number(item)) || {},
                            'is_face_verified'
                          )
                        ) === 1
                          ? 'info'
                          : 'red'
                      "
                    >
                      {{
                        Number(
                          getDeepObj(
                            members.find((data) => Number(data.user_id) === Number(item)) || {},
                            'is_face_verified'
                          )
                        ) === 1
                          ? 'Sudah Verifikasi'
                          : 'Belum Verifikasi'
                      }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      editable: false,
      items: [],
      selectedItems: [],
      textSearch: null,
      grup: {},
      dialog: false,
      page: null,
      cp: 1,
      defGrup: {
        nama: null,
        keterangan: null,
      },
      headers: [
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: 'NIP', align: 'left', value: 'no_pegawai' },
        { text: 'Verifikasi Wajah', align: 'left', value: 'is_face_verified' },
      ],
      pagination: {
        sortBy: 'nama',
      },
      current_page: 0,
      jump_page: 0,
      selection: [],
      pagging: {},
      page_key: 0,
      totalPagination: [],
      debounce: null,
      members: [],
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page
        this.jump_page = n.current_page
        this.page_key = Math.random()
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i)
        }
      }
    },
    items() {
      this.current_page = this.page ? this.page.current_page : 0
    },
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset()
      this.selectedItems = []
      this.cp = 1
      this.textSearch = ''
      this.members = []

      this.grup = typeof obj === 'undefined' ? { ...this.defGrup } : { ...obj }

      if (obj) {
        this.items = []
        this.loadMember(obj.group_id)
      } else {
        this.items = []
      }
      this.getUser()
      return this.$refs.dlg.open()
    },
    change() {
      if (this.current_page !== this.page.current_page) {
        this.cp = this.current_page
        this.getUser()
      }
    },
    getAllUser() {
      this.$store
        .dispatch('user/getUserAktif', {
          organisasi_id: this.organisasi_id,
        })
        .then((res) => {
          this.members = res.data || []
        })
        .catch((e) => e)
    },
    getUser() {
      this.$store
        .dispatch('user/getUserAktif', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = [...res.data.data]
        })
        .then(() => {
          this.getAllUser()
        })
        .catch((e) => e)
    },
    loadMember(grup_id) {
      this.selectedItems = []
      this.$store
        .dispatch('grup/getMember', grup_id)
        .then((res) => {
          const members = res.data.members
          this.selectedItems = members.map((item) => item.user_id)
        })
        .catch((e) => e)
    },
    searchInput() {
      clearTimeout(this.debouce)
      this.debouce = setTimeout(() => {
        this.getUser()
      }, 1000)
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          let filterSelect = []
          this.selectedItems.forEach((key) => {
            const find = this.members.find((s) => Number(s.user_id) === Number(key)) || {}
            if (Object.keys(find).length) {
              filterSelect.push(find)
            }
          })
          this.grup.members = filterSelect
          return this.$store.dispatch('grup/form', {
            organisasi_id: this.organisasi_id,
            grup: this.grup,
          })
        })
        .then((res) => {
          this.grup = this.defGrup
          this.$refs.dlg.resolve()
          return res
        })
        .catch((e) => e)
    },
    onShowSelected() {
      this.dialog = true
    },
  },
}
</script>
